import { render, staticRenderFns } from "./Promotion_manage_exp.vue?vue&type=template&id=5f6c22f6&scoped=true&"
import script from "./Promotion_manage_exp.vue?vue&type=script&lang=js&"
export * from "./Promotion_manage_exp.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_manage_exp.vue?vue&type=style&index=0&id=5f6c22f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c22f6",
  null
  
)

export default component.exports